<template>
  <div>
    <p>Created By Sarthak Neupane</p>
    <p>
      This product uses the TMDb API but is not endorsed or certified by TMDb.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
div {
  /* position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9999999; */
  background: black;
  color: white;
  width: 100%;
  padding: 2rem 1rem 1rem 1rem;
}
p {
  width: 100%;
  text-align: center;
}
p:nth-of-type(2) {
  font-size: 0.5rem;
}
</style>
